import { render, staticRenderFns } from "./TaxIdInput.vue?vue&type=template&id=330a18a4"
import script from "./TaxIdInput.vue?vue&type=script&lang=js"
export * from "./TaxIdInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaxIdInput.vue"
export default component.exports